if (!customElements.get('product-bundle-add')) {
  class ProductBundleAdd extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.js-bundle-add');
      this.errorEl = this.querySelector('.js-bundle-error');
      this.dataEl = this.querySelector('.js-bundle-items-data');

      if (this.btn) {
        this.btn.addEventListener('click', this.handleAdd.bind(this));
      }
    }

    getItems() {
      if (!this.dataEl) return [];
      try {
        return JSON.parse(this.dataEl.textContent);
      } catch (e) {
        return [];
      }
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.hidden = !message;
      this.errorEl.textContent = message || '';
    }

    async handleAdd() {
      const items = this.getItems().filter((item) => item && item.id);

      if (!items.length || !this.btn) return;

      this.setError('');
      this.btn.setAttribute('aria-disabled', 'true');
      this.btn.classList.add('is-loading');

      const cartDrawer = document.querySelector('cart-drawer');
      let sections = 'cart-icon-bubble';

      if (cartDrawer) {
        const drawerSection = cartDrawer.closest('.shopify-section');
        if (drawerSection && drawerSection.id) {
          sections += `,${drawerSection.id.replace('shopify-section-', '')}`;
        }
      }

      const body = {
        items,
        sections,
        sections_url: window.location.pathname
      };

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        });

        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;

        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', ')).join('\n');
        }

        if (data.status) {
          this.setError(Array.isArray(error) ? error.join('\n') : error);
          throw new Error(data.status);
        }

        if (!response.ok) throw new Error(response.status);

        if (window.ProductForm && typeof ProductForm.updateCartIcon === 'function') {
          ProductForm.updateCartIcon(data);
        }

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else if (cartDrawer) {
          setTimeout(() => {
            cartDrawer.renderContents(data, ['drawer', 'hybrid'].includes(theme.settings.afterAtc));
          }, 300);
        }

        this.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: data } }));
        this.btn.classList.add('is-success');
      } catch (err) {
        console.log(err); // eslint-disable-line
        if (cartDrawer) cartDrawer.refresh(true);
      } finally {
        this.btn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.btn.classList.remove('is-loading');
          this.btn.classList.remove('is-success');
        }, 1400);
      }
    }
  }

  customElements.define('product-bundle-add', ProductBundleAdd);
}
